import Utils from "../utils";

const MenuHelper = {};

/**
 * 获取完整的路由路径，包括后端路由及前端路由
 * @return Array
 */
MenuHelper.getFullPath = (hashRoute) => {
  let backendPath,frontendPath;
  // 后端路由
  backendPath = location.pathname.split("/");
  // 前端路由
  if (hashRoute) {
    frontendPath = hashRoute.split("/");
  } else {
    frontendPath = location.hash.split("/");
  }
  const fullPath = backendPath
    .concat(frontendPath)
    .filter((item) => item && item.match(/^\w+/))
  return fullPath;
};

/**
 * 搜索指定key
 * @return Boolean
 */
MenuHelper.searchKey = (key, menu = []) => {
  for (let i = 0, len = menu.length; i < len; i++) {
    const item = menu[i];
    if (key === item.key) {
      return true;
    } else if (item.children) {
      const temp = MenuHelper.searchKey(key, item.children);
      if (temp) {
        return true;
      }
    }
  }
  return false;
};

/**
 * 将嵌套的Menu结构扁平化
 * @return Object
 */
MenuHelper.hashMenu = (menu = []) => {
  const obj = {};
  function getItem(arr, parent, result) {
    for (let i = 0; i < arr.length; i++) {
      result[arr[i].key] = {
        ...arr[i],
        parent,
      };
      if (arr[i].children) {
        getItem(arr[i].children, arr[i].key, result);
      }
      // 其他不在menu展示的page
      if (arr[i].otherPage) {
        getItem(arr[i].otherPage, arr[i].key, result);
      }
    }
  }
  getItem(menu, "", obj);
  return obj;
};

/**
 * URL生成，内部已经处理了生产环境和开发环境
 * @param originArray 路由array，与menu中一一相对，如订单调度台 [ 'dispatch', 'operate' ];
 * @param menu 一般不传此参数，特殊的无法找到actionRoot的情况可使用此辅助完成；
 * @param additionalParams 附加参数，会添加至路由结尾处，hash之后，如 { 'shop_id', 199900 };
 * @return String url相对路径
 */
MenuHelper.makeUrl = (originArray, menu = [], additionalParams = {}) => {
  let realPath = originArray.join("/");
  let query = "";
  let href = "";
  const hashMenu = MenuHelper.hashMenu(menu);
  for (let i = 0; i < originArray.length; i++) {
    if (hashMenu[originArray[i]]) {
      if (hashMenu[originArray[i]].hash !== false) {
        realPath = realPath.replace(
          `/${originArray[i]}`,
          `#/${originArray[i]}`
        );
        break;
      }
    }
  }
  href = `/ams/${realPath}`;
  if(originArray && originArray.length === 1 ) {
    href = `/ams/${realPath}#/`;
  };

  if (!Utils.isEmptyObject(additionalParams)) {
    query = Object.keys(additionalParams)
      .map((item) => `${item}=${additionalParams[item]}`)
      .join("&");
    href += `?${query}`;
  }
  return {href, hashMenu};
};

export default MenuHelper;

